import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class AlertComponent {

    @Input() title: string | null = null;
    @Input() description: string | null = null;

}
